import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function UserSearchEmptyState() {
  return /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: "empty-state-charts",
    title: I18n.text('app-governance-lib.userSearch.emptyState.title'),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.userSearch.emptyState.description"
    })
  });
}